/**
 * Redirect Controller
 *
 * Handles programmatic navigation via Turbo within turbo frames and turbo streams.
 * Used when server needs to trigger client-side navigation (e.g., after successful
 * Turbo Stream operations like collection deletion, location updates).
 *
 * Usage:
 *   <%= tag.template data: { controller: 'redirect', redirect_url_value: some_path } %>
 *
 * @extends ApplicationController
 */

import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static values = { url: String }

  connect() {
    // Track the navigation event before redirecting
    this.addBreadcrumb('Navigation', 'redirect', {
      url: this.urlValue,
    })

    Turbo.visit(this.urlValue)
    this.element.remove()
  }
}
